import { TopBar } from "@/components/layout/TopBar";
import { StreamProvider } from "@/context/StreamContext";

export function Shell({ children }) {
  return (
    <StreamProvider>
      <div className="min-h-screen bg-[#0b0e11]">
        <TopBar />
        <main className="max-w-[1600px] mx-auto px-2 sm:px-3 py-3">{children}</main>
      </div>
    </StreamProvider>
  );
}
